import { render } from "./BastWarrantyImkpModal.vue?vue&type=template&id=397aa73a"
import script from "./BastWarrantyImkpModal.vue?vue&type=script&lang=js"
export * from "./BastWarrantyImkpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__